var _parseOrigin;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useMemo } from 'react';
import { parseOrigin, CidMap, getValueByCid } from '@foody/common';
import { DefaultOthersSupportCid, isArray, showHideForCid } from './utils';
var CurrentCid = ((_parseOrigin = parseOrigin()) === null || _parseOrigin === void 0 ? void 0 : _parseOrigin.cid) || CidMap.id;
export default (function (props) {
  var _props$cid = props.cid,
      cid = _props$cid === void 0 ? CidMap.id : _props$cid,
      children = props.children,
      _props$hidden = props.hidden,
      hidden = _props$hidden === void 0 ? false : _props$hidden; // 该逻辑,在映射的地区上线时，需要废弃

  var customizeCid = useMemo(function () {
    if (!isArray(cid)) {
      return cid === CidMap.id ? [CidMap.id].concat(_toConsumableArray(DefaultOthersSupportCid)) : cid;
    }

    return cid.includes(CidMap.id) ? [].concat(_toConsumableArray(cid), _toConsumableArray(DefaultOthersSupportCid)) : cid;
  }, []);
  var hasValidCid = showHideForCid(customizeCid);
  var emptyRender = /*#__PURE__*/React.createElement(React.Fragment, null);
  var customizeRender = /*#__PURE__*/React.createElement(React.Fragment, null, children);

  if (hasValidCid && !hidden || !hasValidCid && hidden) {
    return customizeRender;
  }

  return emptyRender;
});
export { getValueByCid, CurrentCid };